module.exports = __webpack_public_path__ + "img/fr.578e8ce4.svg";